import {useModalTask} from '../../../services';
import {AlertScreen} from '.';

export const useAlertTask = () => useModalTask<boolean>(AlertScreen);
